module.exports = __webpack_public_path__ + "static/media/myEnterprise.a94b2c02.svg";